const DEACTIVATE_HEADER_TOGGLING = 'DEACTIVATE_HEADER_TOGGLING'
const ACTIVATE_HEADER_TOGGLING = 'ACTIVATE_HEADER_TOGGLING'

const intialState = {
  isHeaderTogglingActive: true
}

export default function header (state = intialState, action) {
  switch (action.type) {
    case ACTIVATE_HEADER_TOGGLING:
      return { ...state, isHeaderTogglingActive: true }
    case DEACTIVATE_HEADER_TOGGLING:
      return { ...state, isHeaderTogglingActive: false }
    default:
      return state
  }
}

export function deactivateHeaderToggling () {
  return { type: DEACTIVATE_HEADER_TOGGLING }
}

export function activateHeaderToggling () {
  return { type: ACTIVATE_HEADER_TOGGLING }
}
